<template>
  <div class="changePartner" ref="base">
    <div v-if="isShowForm" class="wrapper">
      <form ref="submitData" class="changePartner__form">
        <input type="hidden" name="_token" :value="csrfToken">
        <div class="changePartner__form__contents">
          <form-input
            name="target_nickname"
            type="text"
            v-model="submitData.target_nickname"
            label="ニックネーム"
            placeholder="全角・半角英数字15文字以内"
            :is-required="checkRequired('target_nickname')"
            :validation="{ rules: makeValidation('target_nickname',{max: 15}) }"
          />
          <div class="changePartner__form__set">
            <form-input
              name="target_last_name"
              type="text"
              v-model="submitData.target_last_name"
              label="姓"
              :is-required="checkRequired('target_last_name')"
              :validation="{ rules: makeValidation('target_last_name',{max: 5}) }"
            />
            <form-input
              name="target_first_name"
              type="text"
              v-model="submitData.target_first_name"
              label="名"
              :is-required="checkRequired('target_first_name')"
              :validation="{ rules: makeValidation('target_first_name',{max: 5}) }"
            />
          </div>
          <div class="changePartner__form__set">
            <form-input
              name="target_last_name_kana"
              type="text"
              v-model="submitData.target_last_name_kana"
              label="せい"
              :is-required="checkRequired('target_last_name_kana')"
              :validation="{ rules: makeValidation('target_last_name_kana',{max: 11, hiraganaOnly: true}) }"
            />
            <form-input
              name="target_first_name_kana"
              type="text"
              v-model="submitData.target_first_name_kana"
              label="めい"
              :is-required="checkRequired('target_first_name_kana')"
              :validation="{ rules: makeValidation('target_first_name_kana',{max: 11, hiraganaOnly: true}) }"
            />
          </div>
          <form-date
            v-model="submitData.target_birthday"
            label="生年月日"
            name="target_birthday"
            :is-required-label="checkRequired('target_birthday')"
            :validation="{ rules: makeValidation('target_birthday') }"
          />
          <form-time
            name="target_birthtime"
            v-model="submitData.target_birthtime"
            label="出生時間（母子手帳に書いています）"
            :is-required="checkRequired('target_birthtime')"
            :validation="{ rules: makeValidation('target_birthtime') }"
          />
          <form-radio
            v-model="submitData.target_gender"
            design="radio"
            name="target_gender"
            label="性別"
            :default-no-check="true"
            :options="FORM_OPTIONS.gender"
            :is-required="checkRequired('target_gender')"
            :validation="{ rules: makeValidation('target_gender')}"
          />
          <form-select
            v-model="submitData.target_blood"
            label="血液型"
            name="target_blood"
            style="width: 144px"
            :options="FORM_OPTIONS.blood"
            :is-required="checkRequired('target_blood')"
            :validation="{ rules: makeValidation('target_blood') }"
          />
          <form-radio
            name="target_love_status"
            v-model="submitData.target_love_status"
            design="radio"
            label="結婚状況"
            :default-no-check="true"
            :options="FORM_OPTIONS.marriage_status"
            :is-required="checkRequired('target_love_status')"
            :validation="{ rules: makeValidation('target_love_status') }"
            />
          <form-select
            name="target_from_pref"
            style="width: 144px"
            v-model="submitData.target_from_pref"
            label="出生地"
            :options="FORM_OPTIONS.from_pref"
            :is-required="checkRequired('target_from_pref')"
            :validation="{ rules: makeValidation('target_from_pref')  }"
          />
          <form-select
            name="target_living_place"
            style="width: 144px"
            v-model="submitData.target_living_place"
            label="現在のお住まい"
            :options="FORM_OPTIONS.from_pref"
            :is-required="checkRequired('target_living_place')"
            :validation="{ rules: makeValidation('target_living_place') }"
            />
          <form-select
            name="target_birthorder"
            style="width: 144px"
            v-model="submitData.target_birthorder"
            label="出まれ順"
            :options="FORM_OPTIONS.birthorder"
            :is-required="checkRequired('target_birthorder')"
            :validation="{ rules: makeValidation('target_birthorder') }"
            />
        </div>
        <BaseButton
          class="changePartner__button"
          label="登録する"
          :btn-label-enable="true"
          :class="{disabled: buttonIsDisabled}"
          :is-disabled="buttonIsDisabled"
          @clicked="updateProfile"/>
      </form>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import * as type from '@/utvStore/store/mutation-types'
import fetchAccountData from '@/utils/fetchAccountData'
import convertUserInfo from '@/utils/convertUserInfo'
import BaseButton from '@/utvStore/components/common/BaseButton'
import { FORM_LABELS, FORM_OPTIONS, FORM_DATA } from '@/CONSTS'

export default {
  name: 'ChangePertner',
  components:{
    BaseButton,
  },
  props: {
    csrfToken: {
      type: String,
      default: ''
    },
    trigger: {
      type: Boolean,
      default: ()=>false
    },
    closeTrigger: {
      type: Boolean,
      default: ()=>false
    },
    requiredList: {
      type: Array,
      default: ()=>[]
    },
    partnerData:{
      type: Object,
      default: null
    }
  },
  data() {
    return {
      FORM_OPTIONS,
      // validateFlags: {},
      buttonIsDisabled: false,
      targetRequiredList: [],
      isShowForm: false,
      submitData:{
        target_nickname:'',
        target_birthday:'',
        target_gender:'',
        target_blood:'',
        target_last_name:'',
        target_first_name:'',
        target_last_name_kana:'',
        target_first_name_kana:'',
        target_birthtime:'',
        target_from_pref:'',
        target_birthorder:'',
        target_living_place:'',
        target_love_status:'',
      },
    }
  },
  watch:{
    trigger(val) {
      if (val) {
        // 相手の必須項目を配列に詰める
        this.targetRequiredList = this.requiredList.map(required =>{
          return Object.keys(required)[0].replace(/[A-Z]/g, s => "_" + s.charAt(0).toLowerCase())
        }).filter(snake => snake.includes('target'))

        this.base.classList.add('enabled')
        this.base.addEventListener('transitionend', this.onOpenComplete)
        setTimeout(() => this.base.classList.add('open'), 100)
   
        if(this.partnerData) this.submitData = Object.assign({}, this.partnerData)
        else this.submitData = {}

        this.buttonIsDisabled = false
        this.isShowForm = true
        window.scrollTo(0, 0)
      }else{
        this.isShowForm = false
      }
    },
    closeTrigger(val) {
      if (val) {
        this.isShowForm = false
        this.closeDetail()
      }
    },
    validateFlags: {
      handler(n,o) {
        this.buttonIsDisabled = Object.keys(n).some((key)=>{
          return n[key].invalid
        })
      },
      deep: true
    },
  },
  computed: {
    validateFlags () {
      return this.$validator.flags
    },
    ...mapState({
      accessToken: state => state.auth.accessToken,
      globalLock: state => state.uiState.globalLock
    }),
    ...mapGetters(['isLoggedIn'])
  },
  mounted(){
    this.base = this.$refs.base
  },
  methods: {
    updateProfile() {
      if (!this.isLoggedIn || !this.accessToken) return Promise.resolve()
      const formData = $(this.$refs.submitData).serializeArray()
      let tmpdata = {}
      formData.forEach(item => {
        Object.assign(tmpdata, {
          [item.name]: item.value
        })
      })
      tmpdata = convertUserInfo(tmpdata)
      this.$set(tmpdata, 'access_token', this.accessToken)
      if(this.submitData.friend_id) this.$set(tmpdata, 'friend_id', this.submitData.friend_id)
      if(tmpdata.partner_birth_date === 'Invalid date') this.$set(tmpdata, 'partner_birth_date', '')
      this.$emit('loader-enable')
      //this.$store.dispatch(type.GLOBAL_LOCK, true)
      this.buttonIsDisabled = true
      fetchAccountData.updateProfile(tmpdata)
        .then(() => {
          this.$emit('update-info')
          this.closeDetail()
          })
        .catch(err => console.error(err))
    },
    closeDetail() {
      this.base.classList.remove('open')
      this.base.addEventListener('transitionend', this.onCloseComplete)
    },
    onOpenComplete() {
      this.base.removeEventListener('transitionend', this.onOpenComplete)
    },
    onCloseComplete() {
      this.base.removeEventListener('transitionend', this.onCloseComplete)
      this.base.classList.remove('enabled')
      this.base.classList.remove('open')
      this.$emit('close-complete')
    },
    makeValidation(name, addValidation){
      const validation = {}
      if(this.checkRequired(name)) {
        const requireObj = name === 'target_birthday' ? { birthRange: true } : { required: true }
        Object.assign(validation, requireObj)
      }
      if(addValidation) Object.assign(validation, addValidation);
      return validation
    },
    checkRequired(name){
      return this.targetRequiredList.some((requiredItem)=>requiredItem === name)
    }
  }
}</script>

<style lang="scss">
@import "../../../../sass/commons/commonVariables.scss";
.changePartner{
  color: $col_base_black;
  padding: 44px 0px 50px;
  width: 100%;
  height: 100%;
  position: fixed;
  left: 100%;
  transition: transform 200ms ease-out 0s;
  background: $col_verylite_gray;
  display: none;
  top: 0;

  @include mq('pc') {
    padding: 44px 0 0;
  }

  /deep/ .baseButton__button__label {
    &::before{
      z-index: 1;
    }
    &::after{
      content: "登録する";
      color: $col_temp_key1;
      background: $col_def_gradient;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      position: absolute;
      line-height: 1em;
      height: 1em;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
      display: inline-block;
      z-index: 3;
    }
  }

  .changePartner__button {
    &.disabled {
      filter: grayscale(1) brightness(1.4);
    }
  }

  .wrapper {
    max-width: 580px;
    max-height: 100%;
    margin: 0 auto;
    width: 100%;
    height: 100%;
    position: relative;
    overflow-x: hidden;
    overflow-y: auto;
  }

  &.enabled {
    display: block;
  }

  &.open {
    transform: translate3d(-100%, 0, 0);
  }

  &__form{
    padding: 35px 30px;
    min-height: 100%;
    background: url('/static/img/common/background/bg_def_moya1.jpg') no-repeat,
      url('/static/img/common/background/bg_def_moya2.jpg') no-repeat;
    background-size: 100% auto, 100% auto;
    background-position: 0 0, 100% calc(100% - 20px);
    background-color: #fff;
    &__contents{
      margin-bottom: 30px;
      > div > .formGroup { margin-bottom: 20px;}
      > div:last-child > .formGroup { margin-bottom: 0;}
    }
    &__set{
      display: flex;
        div + div{
          margin-left: 3px;
        }
    }
  }

  &__button{
    margin: 40px 0;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/partials/ChangePartner.vue